<template>
  <div class="v5-ph">
    <div class="v5-ph__title">
      <h1>
        <template v-for="(p, i) in parents" :key="i">
          <router-link :to="p.to">{{ p.label }}</router-link><span class="v5-ph__sep" aria-hidden="true">/</span>
        </template><slot name="title">{{ title }}</slot>
      </h1>
      <div v-if="$slots.meta" class="v5-ph__meta">
        <slot name="meta" />
      </div>
      <div v-if="$slots.actions" class="v5-ph__acts">
        <slot name="actions" />
      </div>
    </div>
    <slot />
    <slot name="tabs" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

// The head every top-level v5 page opens with (styles in v5.css, .v5-ph): title and page
// actions, then the tabs. `parent` turns the title into a
// breadcrumb on sub-pages: { to, label }, or a list of them for deeper pages. The title slot
// replaces the text; meta sits beside it. The default slot sits between the title row and the tabs.
const props = defineProps({
  title: { type: String, default: '' },
  parent: { type: [Object, Array], default: null },
});
const parents = computed(() => [props.parent ?? []].flat());
</script>
